"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_CMS_ENTERPRISE_ONBOARDING = exports.SERVICE_CMS_PROFESSIONAL_ONBOARDING = exports.SERVICE_SERVICE_STARTER_ONBOARDING = exports.SERVICE_SALES_STARTER_ONBOARDING = exports.SERVICE_MARKETING_STARTER_ONBOARDING = exports.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019 = exports.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 = exports.SERVICE_LATAM_MARKETING_ENTERPRISE_ONBOARDING = exports.SERVICE_LATAM_MARKETING_PROFESSIONAL_ONBOARDING = exports.SERVICE_FIRST_TIME_FULL_MIGRATION = exports.SERVICE_PREMIUM_CONSULTING = exports.SERVICE_INBOUND_CONSULTING_ONGOING = exports.SERVICE_INBOUND_CONSULTING_MONTHLY = exports.SERVICE_TECHNICAL_CONSULTING_ONGOING = exports.SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING = exports.SERVICE_CONTENT_PROFESSIONAL_ONBOARDING = exports.SERVICE_PROFESSIONAL_SUITE_ONBOARDING = exports.SERVICE_ENTERPRISE_SUITE_ONBOARDING = exports.SERVICE_SERVICE_ENTERPRISE_ONBOARDING = exports.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING = exports.SERVICE_SALES_ENTERPRISE_ONBOARDING = exports.SERVICE_SALES_PROFESSIONAL_ONBOARDING = exports.SERVICE_CRM_SALES_STARTER_KIT = exports.SERVICE_MARKETING_ENTERPRISE_ONBOARDING = exports.SERVICE_MARKETING_PROFESSIONAL_ONBOARDING = exports.SERVICE_MARKETING_BASIC_ONBOARDING = exports.SERVICE_CONSULTING_SALES_SKILLS = exports.SERVICE_CONSULTING_AGENCY_PIPELINE = exports.SERVICE_TECH_CONSULTING_FOUR_HOURS = exports.SERVICE_TECH_CONSULTING_ONE_DAY = exports.SERVICE_DESIGNATED_TECHNICAL_SUPPORT = exports.SERVICE_INBOUND_CONSULTING_FOUR_HOUR = exports.SERVICE_INBOUND_CONSULTING_ONE_DAY = exports.SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT = exports.SERVICE_TRAINING_CRM_MANAGEMENT = exports.SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT = exports.SERVICE_TRAINING_MARKETING_FUNDAMENTALS = exports.SERVICE_TEMPLATE_SETUP = exports.SERVICE_FIRST_TEMPLATE_SETUP = exports.LIMIT_INCREASE_REPORTING = exports.ADDON_LISTS = exports.ADDON_WORKFLOWS = exports.ADDON_BRAND_DOMAIN = exports.ADDON_WEBSITE_UNLIMITED = exports.ADDON_WEBSITE_STARTER = exports.ADDON_CUSTOM_SSL = exports.ADDON_TRANSACTIONAL_EMAIL = exports.ADDON_REPORTING = exports.ADDON_DEDICATED_IP = exports.ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS = exports.ADDON_ADS_CAPACITY = exports.ADDON_ADS = exports.ADDON_API = exports.PRODUCT_CMS_ENTERPRISE = exports.PRODUCT_CMS_PROFESSIONAL = exports.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = exports.PRODUCT_SERVICE_ENTERPRISE = exports.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = exports.PRODUCT_SERVICE_PROFESSIONAL = exports.PRODUCT_SERVICE_STARTER_ADDL_USER_MAR_2020 = exports.PRODUCT_SERVICE_STARTER_MAR_2020 = exports.PRODUCT_SERVICE_STARTER = exports.PRODUCT_SERVICE_FREE = exports.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = exports.PRODUCT_SALES_ENTERPRISE = exports.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER_NOV_2019 = exports.PRODUCT_SALES_PROFESSIONAL_NOV_2019 = exports.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = exports.PRODUCT_SALES_PROFESSIONAL = exports.PRODUCT_SALES_STARTER_ADDL_USER_MAR_2020 = exports.PRODUCT_SALES_STARTER_MAR_2020 = exports.PRODUCT_SALES_STARTER = exports.PRODUCT_SALES_PRO_BUSINESS_USER = exports.PRODUCT_SALES_PRO_LEGACY = exports.PRODUCT_SALES_FREE = exports.PRODUCT_MARKETING_ENTERPRISE_CONTACTS_MC = exports.PRODUCT_MARKETING_ENTERPRISE_MC = exports.PRODUCT_MARKETING_ENTERPRISE_CONTACTS = exports.PRODUCT_MARKETING_ENTERPRISE = exports.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS_MC = exports.PRODUCT_MARKETING_PROFESSIONAL_MC = exports.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS = exports.PRODUCT_MARKETING_PROFESSIONAL = exports.PRODUCT_MARKETING_BASIC_CONTACTS = exports.PRODUCT_MARKETING_BASIC = exports.PRODUCT_MARKETING_STARTER_CONTACTS_MC = exports.PRODUCT_MARKETING_STARTER_MC = exports.PRODUCT_MARKETING_STARTER_CONTACTS_NOV_2019 = exports.PRODUCT_MARKETING_STARTER_NOV_2019 = exports.PRODUCT_MARKETING_STARTER_CONTACTS = exports.PRODUCT_MARKETING_STARTER_EMAIL = exports.PRODUCT_MARKETING_STARTER = exports.PRODUCT_MARKETING_FREE = exports.PRODUCT_CRM = void 0;
var PRODUCT_CRM = 60;
exports.PRODUCT_CRM = PRODUCT_CRM;
var PRODUCT_MARKETING_FREE = 114;
exports.PRODUCT_MARKETING_FREE = PRODUCT_MARKETING_FREE;
var PRODUCT_MARKETING_STARTER = 108;
exports.PRODUCT_MARKETING_STARTER = PRODUCT_MARKETING_STARTER;
var PRODUCT_MARKETING_STARTER_EMAIL = 250;
exports.PRODUCT_MARKETING_STARTER_EMAIL = PRODUCT_MARKETING_STARTER_EMAIL;
var PRODUCT_MARKETING_STARTER_CONTACTS = 251;
exports.PRODUCT_MARKETING_STARTER_CONTACTS = PRODUCT_MARKETING_STARTER_CONTACTS;
var PRODUCT_MARKETING_STARTER_NOV_2019 = 339;
exports.PRODUCT_MARKETING_STARTER_NOV_2019 = PRODUCT_MARKETING_STARTER_NOV_2019;
var PRODUCT_MARKETING_STARTER_CONTACTS_NOV_2019 = 340;
exports.PRODUCT_MARKETING_STARTER_CONTACTS_NOV_2019 = PRODUCT_MARKETING_STARTER_CONTACTS_NOV_2019;
var PRODUCT_MARKETING_STARTER_MC = 380;
exports.PRODUCT_MARKETING_STARTER_MC = PRODUCT_MARKETING_STARTER_MC;
var PRODUCT_MARKETING_STARTER_CONTACTS_MC = 381;
exports.PRODUCT_MARKETING_STARTER_CONTACTS_MC = PRODUCT_MARKETING_STARTER_CONTACTS_MC;
var PRODUCT_MARKETING_BASIC = 182;
exports.PRODUCT_MARKETING_BASIC = PRODUCT_MARKETING_BASIC;
var PRODUCT_MARKETING_BASIC_CONTACTS = 191;
exports.PRODUCT_MARKETING_BASIC_CONTACTS = PRODUCT_MARKETING_BASIC_CONTACTS;
var PRODUCT_MARKETING_PROFESSIONAL = 183;
exports.PRODUCT_MARKETING_PROFESSIONAL = PRODUCT_MARKETING_PROFESSIONAL;
var PRODUCT_MARKETING_PROFESSIONAL_CONTACTS = 192;
exports.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS = PRODUCT_MARKETING_PROFESSIONAL_CONTACTS;
var PRODUCT_MARKETING_PROFESSIONAL_MC = 387;
exports.PRODUCT_MARKETING_PROFESSIONAL_MC = PRODUCT_MARKETING_PROFESSIONAL_MC;
var PRODUCT_MARKETING_PROFESSIONAL_CONTACTS_MC = 388;
exports.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS_MC = PRODUCT_MARKETING_PROFESSIONAL_CONTACTS_MC;
var PRODUCT_MARKETING_ENTERPRISE = 184;
exports.PRODUCT_MARKETING_ENTERPRISE = PRODUCT_MARKETING_ENTERPRISE;
var PRODUCT_MARKETING_ENTERPRISE_CONTACTS = 193;
exports.PRODUCT_MARKETING_ENTERPRISE_CONTACTS = PRODUCT_MARKETING_ENTERPRISE_CONTACTS;
var PRODUCT_MARKETING_ENTERPRISE_MC = 389;
exports.PRODUCT_MARKETING_ENTERPRISE_MC = PRODUCT_MARKETING_ENTERPRISE_MC;
var PRODUCT_MARKETING_ENTERPRISE_CONTACTS_MC = 390;
exports.PRODUCT_MARKETING_ENTERPRISE_CONTACTS_MC = PRODUCT_MARKETING_ENTERPRISE_CONTACTS_MC;
var PRODUCT_SALES_FREE = 115;
exports.PRODUCT_SALES_FREE = PRODUCT_SALES_FREE;
var PRODUCT_SALES_PRO_LEGACY = 1; // This product is no longer active and is the legacy legacy sales pro

exports.PRODUCT_SALES_PRO_LEGACY = PRODUCT_SALES_PRO_LEGACY;
var PRODUCT_SALES_PRO_BUSINESS_USER = 4;
exports.PRODUCT_SALES_PRO_BUSINESS_USER = PRODUCT_SALES_PRO_BUSINESS_USER;
var PRODUCT_SALES_STARTER = 186;
exports.PRODUCT_SALES_STARTER = PRODUCT_SALES_STARTER;
var PRODUCT_SALES_STARTER_MAR_2020 = 359;
exports.PRODUCT_SALES_STARTER_MAR_2020 = PRODUCT_SALES_STARTER_MAR_2020;
var PRODUCT_SALES_STARTER_ADDL_USER_MAR_2020 = 360;
exports.PRODUCT_SALES_STARTER_ADDL_USER_MAR_2020 = PRODUCT_SALES_STARTER_ADDL_USER_MAR_2020;
var PRODUCT_SALES_PROFESSIONAL = 198;
exports.PRODUCT_SALES_PROFESSIONAL = PRODUCT_SALES_PROFESSIONAL;
var PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = 200;
exports.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER;
var PRODUCT_SALES_PROFESSIONAL_NOV_2019 = 337;
exports.PRODUCT_SALES_PROFESSIONAL_NOV_2019 = PRODUCT_SALES_PROFESSIONAL_NOV_2019;
var PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER_NOV_2019 = 338;
exports.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER_NOV_2019 = PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER_NOV_2019;
var PRODUCT_SALES_ENTERPRISE = 282;
exports.PRODUCT_SALES_ENTERPRISE = PRODUCT_SALES_ENTERPRISE;
var PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = 283;
exports.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER;
var PRODUCT_SERVICE_FREE = 296;
exports.PRODUCT_SERVICE_FREE = PRODUCT_SERVICE_FREE;
var PRODUCT_SERVICE_STARTER = 261;
exports.PRODUCT_SERVICE_STARTER = PRODUCT_SERVICE_STARTER;
var PRODUCT_SERVICE_STARTER_MAR_2020 = 362;
exports.PRODUCT_SERVICE_STARTER_MAR_2020 = PRODUCT_SERVICE_STARTER_MAR_2020;
var PRODUCT_SERVICE_STARTER_ADDL_USER_MAR_2020 = 363;
exports.PRODUCT_SERVICE_STARTER_ADDL_USER_MAR_2020 = PRODUCT_SERVICE_STARTER_ADDL_USER_MAR_2020;
var PRODUCT_SERVICE_PROFESSIONAL = 262;
exports.PRODUCT_SERVICE_PROFESSIONAL = PRODUCT_SERVICE_PROFESSIONAL;
var PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = 263;
exports.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER;
var PRODUCT_SERVICE_ENTERPRISE = 285;
exports.PRODUCT_SERVICE_ENTERPRISE = PRODUCT_SERVICE_ENTERPRISE;
var PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = 286;
exports.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER;
var PRODUCT_CMS_PROFESSIONAL = 383;
exports.PRODUCT_CMS_PROFESSIONAL = PRODUCT_CMS_PROFESSIONAL;
var PRODUCT_CMS_ENTERPRISE = 378;
exports.PRODUCT_CMS_ENTERPRISE = PRODUCT_CMS_ENTERPRISE;
var ADDON_API = 113;
exports.ADDON_API = ADDON_API;
var ADDON_ADS = 9; // Deprecated

exports.ADDON_ADS = ADDON_ADS;
var ADDON_ADS_CAPACITY = 300;
exports.ADDON_ADS_CAPACITY = ADDON_ADS_CAPACITY;
var ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS = 38;
exports.ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS = ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS;
var ADDON_DEDICATED_IP = 33;
exports.ADDON_DEDICATED_IP = ADDON_DEDICATED_IP;
var ADDON_REPORTING = 406;
exports.ADDON_REPORTING = ADDON_REPORTING;
var ADDON_TRANSACTIONAL_EMAIL = 41;
exports.ADDON_TRANSACTIONAL_EMAIL = ADDON_TRANSACTIONAL_EMAIL;
var ADDON_CUSTOM_SSL = 52; // TODO: Figure out merchandiseId
// export const ADDON_CUSTOM_SSL_THIRD_PARTY = null;

exports.ADDON_CUSTOM_SSL = ADDON_CUSTOM_SSL;
var ADDON_WEBSITE_STARTER = 54;
exports.ADDON_WEBSITE_STARTER = ADDON_WEBSITE_STARTER;
var ADDON_WEBSITE_UNLIMITED = 10; // TODO: Figure out merchandiseId
// export const ADDON_ADDITIONAL_PORTAL = null;

exports.ADDON_WEBSITE_UNLIMITED = ADDON_WEBSITE_UNLIMITED;
var ADDON_BRAND_DOMAIN = 297;
exports.ADDON_BRAND_DOMAIN = ADDON_BRAND_DOMAIN;
var ADDON_WORKFLOWS = 376;
exports.ADDON_WORKFLOWS = ADDON_WORKFLOWS;
var ADDON_LISTS = 377;
exports.ADDON_LISTS = ADDON_LISTS;
var LIMIT_INCREASE_REPORTING = 415;
exports.LIMIT_INCREASE_REPORTING = LIMIT_INCREASE_REPORTING;
var SERVICE_FIRST_TEMPLATE_SETUP = 18;
exports.SERVICE_FIRST_TEMPLATE_SETUP = SERVICE_FIRST_TEMPLATE_SETUP;
var SERVICE_TEMPLATE_SETUP = 384;
exports.SERVICE_TEMPLATE_SETUP = SERVICE_TEMPLATE_SETUP;
var SERVICE_TRAINING_MARKETING_FUNDAMENTALS = 268;
exports.SERVICE_TRAINING_MARKETING_FUNDAMENTALS = SERVICE_TRAINING_MARKETING_FUNDAMENTALS;
var SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT = 269;
exports.SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT = SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT;
var SERVICE_TRAINING_CRM_MANAGEMENT = 270;
exports.SERVICE_TRAINING_CRM_MANAGEMENT = SERVICE_TRAINING_CRM_MANAGEMENT;
var SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT = 267;
exports.SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT = SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT;
var SERVICE_INBOUND_CONSULTING_ONE_DAY = 36;
exports.SERVICE_INBOUND_CONSULTING_ONE_DAY = SERVICE_INBOUND_CONSULTING_ONE_DAY;
var SERVICE_INBOUND_CONSULTING_FOUR_HOUR = 37;
exports.SERVICE_INBOUND_CONSULTING_FOUR_HOUR = SERVICE_INBOUND_CONSULTING_FOUR_HOUR;
var SERVICE_DESIGNATED_TECHNICAL_SUPPORT = 39;
exports.SERVICE_DESIGNATED_TECHNICAL_SUPPORT = SERVICE_DESIGNATED_TECHNICAL_SUPPORT;
var SERVICE_TECH_CONSULTING_ONE_DAY = 245;
exports.SERVICE_TECH_CONSULTING_ONE_DAY = SERVICE_TECH_CONSULTING_ONE_DAY;
var SERVICE_TECH_CONSULTING_FOUR_HOURS = 275;
exports.SERVICE_TECH_CONSULTING_FOUR_HOURS = SERVICE_TECH_CONSULTING_FOUR_HOURS;
var SERVICE_CONSULTING_AGENCY_PIPELINE = 175;
exports.SERVICE_CONSULTING_AGENCY_PIPELINE = SERVICE_CONSULTING_AGENCY_PIPELINE;
var SERVICE_CONSULTING_SALES_SKILLS = 176;
exports.SERVICE_CONSULTING_SALES_SKILLS = SERVICE_CONSULTING_SALES_SKILLS;
var SERVICE_MARKETING_BASIC_ONBOARDING = 42;
exports.SERVICE_MARKETING_BASIC_ONBOARDING = SERVICE_MARKETING_BASIC_ONBOARDING;
var SERVICE_MARKETING_PROFESSIONAL_ONBOARDING = 45;
exports.SERVICE_MARKETING_PROFESSIONAL_ONBOARDING = SERVICE_MARKETING_PROFESSIONAL_ONBOARDING;
var SERVICE_MARKETING_ENTERPRISE_ONBOARDING = 44;
exports.SERVICE_MARKETING_ENTERPRISE_ONBOARDING = SERVICE_MARKETING_ENTERPRISE_ONBOARDING;
var SERVICE_CRM_SALES_STARTER_KIT = 57;
exports.SERVICE_CRM_SALES_STARTER_KIT = SERVICE_CRM_SALES_STARTER_KIT;
var SERVICE_SALES_PROFESSIONAL_ONBOARDING = 254;
exports.SERVICE_SALES_PROFESSIONAL_ONBOARDING = SERVICE_SALES_PROFESSIONAL_ONBOARDING;
var SERVICE_SALES_ENTERPRISE_ONBOARDING = 288;
exports.SERVICE_SALES_ENTERPRISE_ONBOARDING = SERVICE_SALES_ENTERPRISE_ONBOARDING;
var SERVICE_SERVICE_PROFESSIONAL_ONBOARDING = 264;
exports.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING = SERVICE_SERVICE_PROFESSIONAL_ONBOARDING;
var SERVICE_SERVICE_ENTERPRISE_ONBOARDING = 289;
exports.SERVICE_SERVICE_ENTERPRISE_ONBOARDING = SERVICE_SERVICE_ENTERPRISE_ONBOARDING;
var SERVICE_ENTERPRISE_SUITE_ONBOARDING = 290;
exports.SERVICE_ENTERPRISE_SUITE_ONBOARDING = SERVICE_ENTERPRISE_SUITE_ONBOARDING;
var SERVICE_PROFESSIONAL_SUITE_ONBOARDING = 291;
exports.SERVICE_PROFESSIONAL_SUITE_ONBOARDING = SERVICE_PROFESSIONAL_SUITE_ONBOARDING;
var SERVICE_CONTENT_PROFESSIONAL_ONBOARDING = 292;
exports.SERVICE_CONTENT_PROFESSIONAL_ONBOARDING = SERVICE_CONTENT_PROFESSIONAL_ONBOARDING;
var SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING = 260;
exports.SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING = SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING;
var SERVICE_TECHNICAL_CONSULTING_ONGOING = 246;
exports.SERVICE_TECHNICAL_CONSULTING_ONGOING = SERVICE_TECHNICAL_CONSULTING_ONGOING;
var SERVICE_INBOUND_CONSULTING_MONTHLY = 247;
exports.SERVICE_INBOUND_CONSULTING_MONTHLY = SERVICE_INBOUND_CONSULTING_MONTHLY;
var SERVICE_INBOUND_CONSULTING_ONGOING = 248;
exports.SERVICE_INBOUND_CONSULTING_ONGOING = SERVICE_INBOUND_CONSULTING_ONGOING;
var SERVICE_PREMIUM_CONSULTING = 249;
exports.SERVICE_PREMIUM_CONSULTING = SERVICE_PREMIUM_CONSULTING;
var SERVICE_FIRST_TIME_FULL_MIGRATION = 272;
exports.SERVICE_FIRST_TIME_FULL_MIGRATION = SERVICE_FIRST_TIME_FULL_MIGRATION;
var SERVICE_LATAM_MARKETING_PROFESSIONAL_ONBOARDING = 322;
exports.SERVICE_LATAM_MARKETING_PROFESSIONAL_ONBOARDING = SERVICE_LATAM_MARKETING_PROFESSIONAL_ONBOARDING;
var SERVICE_LATAM_MARKETING_ENTERPRISE_ONBOARDING = 321;
exports.SERVICE_LATAM_MARKETING_ENTERPRISE_ONBOARDING = SERVICE_LATAM_MARKETING_ENTERPRISE_ONBOARDING;
var SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 = 335;
exports.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 = SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019;
var SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019 = 336;
exports.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019 = SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019;
var SERVICE_MARKETING_STARTER_ONBOARDING = 332;
exports.SERVICE_MARKETING_STARTER_ONBOARDING = SERVICE_MARKETING_STARTER_ONBOARDING;
var SERVICE_SALES_STARTER_ONBOARDING = 333;
exports.SERVICE_SALES_STARTER_ONBOARDING = SERVICE_SALES_STARTER_ONBOARDING;
var SERVICE_SERVICE_STARTER_ONBOARDING = 334;
exports.SERVICE_SERVICE_STARTER_ONBOARDING = SERVICE_SERVICE_STARTER_ONBOARDING;
var SERVICE_CMS_PROFESSIONAL_ONBOARDING = 292;
exports.SERVICE_CMS_PROFESSIONAL_ONBOARDING = SERVICE_CMS_PROFESSIONAL_ONBOARDING;
var SERVICE_CMS_ENTERPRISE_ONBOARDING = 379;
exports.SERVICE_CMS_ENTERPRISE_ONBOARDING = SERVICE_CMS_ENTERPRISE_ONBOARDING;